import { v4 as uuidv4 } from "uuid";
import { DocumentCategoryRef } from "../../../../models/document-categories";
import { DocumentTypeRef } from "../../../../models/document-types";
import { Period, PeriodType } from "../../../../models/documents/period";
import { DOCUMENTS_STATUS_TYPES, DOCUMENT_CATEGORIES, DOCUMENT_TYPES } from "../../../../utils/constants/constants";
import { DocumentRef } from "../../../../models/documents/document-ref";
import { saveDocuments } from "../../../../services/documents";

const getDefaultDocument = () => {
  return {
    companyAccount: null,
    createdAt: new Date(0, 0, 1),
    createdByUser: null,
    isDeleted: false,
    id: uuidv4(),
    name: "",
    legalEntity: null,
    employee: null,
    employeeGroup: null,
    client: null,
    vendor: null,
    status: DOCUMENTS_STATUS_TYPES.PENDING,
    published: false,
    filesCount: 0,
    files: [],
    clarifications: [],
    documentTransactions: [],
    category: DOCUMENT_CATEGORIES.OTHER as DocumentCategoryRef,
    type: DOCUMENT_TYPES.Other as DocumentTypeRef,
    period: Period.makePeriod(new Date().getFullYear(), PeriodType.Month, new Date().getMonth() + 1),
    documentDate: new Date(),
  } as DocumentRef;
};

export const saveDocs = async (hasFiles: boolean, hasVocalMessages: boolean) => {
  const resDocs: DocumentRef[] = [];

  let docOne: DocumentRef | null = null;
  let docTwo: DocumentRef | null = null;

  if (hasFiles) {
    docOne = getDefaultDocument();
    resDocs.push(docOne);
  }

  if (hasVocalMessages) {
    docTwo = getDefaultDocument();
    resDocs.push(docTwo);
  }

  const response = !!resDocs.length ? await saveDocuments(resDocs, null, true) : null;

  return {
    response,
    docOne,
    docTwo,
  };
};
